<template><!-- svgo-optimised -->
<svg class="icon icon__check" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9 16.877 10.59-10.58.703.703L9 18.293 4.118 13.41l.71-.705L9 16.876Z"/></svg></template>